<template>
  <div>
    <div class="base-wrap clearfix">
      <div class="base-item">
        <em class="label">报销标题：</em>
        <div class="content">
          {{ formData.title }}
        </div>
      </div>
      <div class="base-item">
        <em class="label">报销人：</em>
        <div class="content">
          {{ formData.real_user_info.name }}
        </div>
      </div>
      <div class="base-item">
        <em class="label">币种类型：</em>
        <div class="content" v-if="formData.coin_type">
          {{ coins.constMap.idMap[formData.coin_type].name || "--/--" }}
        </div>
      </div>
      <div class="base-item">
        <em class="label">公司主体：</em>
        <div class="content" v-if="formData.owner_company_id">
          {{ companysMap[formData.owner_company_id].name || "--/--" }}
        </div>
      </div>
      <div class="base-item">
        <em class="label">项目名称</em>
        <div class="content" v-if="formData.owner_project_info">
          {{ formData.owner_project_info.name }}
        </div>
        <div v-else>--/--</div>
      </div>
      <div class="base-item">
        <em class="label">总金额：</em>
        <div class="content">
          {{ formData.format_sum_money }}
          <span v-if="formData.coin_type">{{
            coins.constMap.idMap[formData.coin_type].tailUnit
          }}</span>
        </div>
      </div>
      <div class="base-item">
        <em class="label">附件：</em>
        <div
          class="content"
          v-if="formData.img_keys && formData.img_keys.length > 0">
          <template v-for="img in formData.img_keys">
            <a
              style="color: #2f78ff;"
              :key="img.key"
              :href="`/api/base/download?key=${img.key}`"
              target="_blank">{{ img.name }}&nbsp;&nbsp;</a>&nbsp;
          </template>
        </div>
        <div class="content" v-else>--/--</div>
      </div>
    </div>
    <el-table
      :data="formData.detail"
      size="mini"
      style="width: 100%; margin-bottom: 20px;">
      <el-table-column prop="name" label="报销类型" width="180">
        <template slot-scope="scope">
          {{
            expenseTypesMap[scope.row.type]
              ? expenseTypesMap[scope.row.type].name
              : "--/--"
          }}
        </template>
      </el-table-column>
      <el-table-column prop="money" label="单项金额" width="180">
        <template slot-scope="scope">
          {{ formatNum(scope.row.money) || 0 }}
          <span v-if="formData.coin_type">{{
            coins.constMap.idMap[formData.coin_type].tailUnit
          }}</span>
        </template>
      </el-table-column>
      <el-table-column label="单项税额" width="180">
        <template slot-scope="scope">
          {{ formatNum(scope.row.sum_tax_amount) || 0 }}
          <span v-if="formData.coin_type">{{
            coins.constMap.idMap[formData.coin_type].tailUnit
          }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="created_at" label="日期" width="180">
      </el-table-column>
      <el-table-column prop="error_msg" label="提示">
        <template slot-scope="scope">
          {{ scope.row.error_msg || "-/-" }}
        </template>
      </el-table-column>
      <el-table-column prop="remark" label="备注"> </el-table-column>
      <el-table-column prop="filename" label="查看发票">
        <template slot-scope="scope">
          <a
            style="color: #2f78ff;"
            :href="`/api/base/download?key=${scope.row.key}`"
            target="_blank">{{ scope.row.key }}</a>
        </template>
      </el-table-column>
    </el-table>
    <div class="split_line">
      <i class="el-icon-price-tag"></i><span>报销类型金额汇总</span>
      <div class="line"></div>
    </div>
    <el-table
      size="mini"
      :data="sumMoneyList"
      style="width: 100%; margin-bottom: 20px;">
      <el-table-column prop="name" label="报销类型"> </el-table-column>
      <el-table-column prop="money" label="金额">
        <template slot-scope="scope">
          {{ formatNum(scope.row.money) }}
          <span v-if="formData.coin_type">{{
            coins.constMap.idMap[formData.coin_type].tailUnit
          }}</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { coins } from '@/const';
import { formatNum } from '@/utils/toTx'
export default {
  name: 'applayReimbursementDetail', // 报销
  props: {
    formData: {
      type: Object,
      default: () => {
        return {};
      },
    },
    expenseTypes: {
      type: Array,
      default: () => {
        return [];
      },
    },
    companysMap: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  created() {
    // console.log(this.companysMap, 'companysMap')
    console.log(this.formData, 'companysMap');
    this.initexpenseTypesMap();
    this.initSumMoney();
  },
  data() {
    return {
      coins,
      expenseTypesMap: {},
      sumMoneyList: [],
    };
  },
  methods: {
    formatNum(num) {
      return formatNum(num)
    },
    initSumMoney() {
      let list = this.expenseTypes.map((item) => {
        return {
          id: item.id,
          name: item.name,
          money: 0,
        };
      });

      list.forEach((typeItem) => {
        this.formData.detail.forEach((item) => {
          if (item.type == typeItem.id) {
            typeItem.money += item.money * 100;
          }
        });
        typeItem.money = typeItem.money / 100;
      });

      this.sumMoneyList = list.filter((item) => {
        return item.money != 0;
      });
    },
    initexpenseTypesMap() {
      let maps = {};
      this.expenseTypes.forEach((item) => {
        maps[item.id] = item;
      });
      this.expenseTypesMap = maps;
    },
  },
};
</script>
<style lang="scss">
.el-link.el-link--primary {
  text-decoration: underline;
}
</style>